import { render, staticRenderFns } from "./CampaignsGrid.vue?vue&type=template&id=079d798b&scoped=true"
import script from "./CampaignsGrid.vue?vue&type=script&lang=ts"
export * from "./CampaignsGrid.vue?vue&type=script&lang=ts"
import style0 from "./CampaignsGrid.vue?vue&type=style&index=0&id=079d798b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079d798b",
  null
  
)

export default component.exports